export const alcoholFrequencyOptions = [
  {
    code: "LA6270-8",
    display: "Nunca",
    value: "Never",
  },
  {
    code: "LA18926-8",
    display: "Mensalmente ou menos",
    value: "Monthly or less",
  },
  {
    code: "LA18927-6",
    display: "2-4 vezes por mês",
    value: "2-4 times a month",
  },
  {
    code: "LA18928-4",
    display: "2-3 vezes por semana",
    value: "2-3 times a week",
  },
  {
    code: "LA18929-2",
    display: "4 ou mais vezes por semana",
    value: "4 or more times a week",
  },
  {
    code: "",
    display: "Limpar",
    value: "",
  },
];

export const smokingOptions = [
  {
    code: "LA18976-3",
    display: "atualmente, fumante diário",
    value: "Current every day smoker",
  },
  {
    code: "LA18977-1",
    display: "atualmente, fumante alguns dias na semana",
    value: "Current some day smoker",
  },
  { code: "LA15920-4", display: "ex-fumante", value: "Former smoker" },
  { code: "LA18978-9", display: "nunca fumou", value: "Never smoker" },
  {
    code: "LA18979-7",
    display: "estado tabagista atual desconhecido",
    value: "Smoker, current status unknown",
  },
  {
    code: "LA18980-5",
    display: "sem conhecimento se já fumou",
    value: "Unknown if ever smoked",
  },
  {
    code: "LA18981-3",
    display: "fumante frequente",
    value: "Heavy tobacco smoker",
  },
  {
    code: "LA18982-1",
    display: "fumante eventual",
    value: "Light tobacco smoker",
  },
  {
    code: "",
    display: "Limpar",
    value: "",
  },
];

export const drugTypeLifetimeOptions = [
  {
    code: "LA15872-7",
    display: "Sedatives",
    value: "Sedatives",
    label: "Sedativos",
  },
  {
    code: "LA15873-5",
    display: "Tranquilizers or anti-anxiety drugs",
    value: "Tranquilizers or anti-anxiety drugs",
    label: "Tranquilizantes ou medicamentos anti-ansiedade",
  },
  {
    code: "LA15874-3",
    display: "Painkillers",
    value: "Painkillers",
    label: "Analgésicos",
  },
  {
    code: "LA15875-0",
    display: "Stimulants",
    value: "Stimulants",
    label: "Estimulantes",
  },
  {
    code: "LA15876-8",
    display: "Marijuana, hash, THC, or grass",
    value: "Marijuana, hash, THC, or grass",
    label: "Maconha, haxixe, THC ou erva",
  },
  {
    code: "LA15877-6",
    display: "Cocaine or crack",
    value: "Cocaine or crack",
    label: "Cocaína ou crack",
  },
  {
    code: "LA15878-4",
    display: "Hallucinogens",
    value: "Hallucinogens",
    label: "Alucinógenos",
  },
  {
    code: "LA15879-2",
    display: "Inhalants or solvents",
    value: "Inhalants or solvents",
    label: "Inalantes ou solventes",
  },
  {
    code: "LA15880-0",
    display: "Heroin",
    value: "Heroin",
    label: "Heroína",
  },
  {
    code: "LA15881-8",
    display: "Any other medicines, drugs, or substances",
    value: "Any other medicines, drugs, or substances",
    label: "Qualquer outro medicamento, droga ou substância",
  },
  {
    code: "",
    display: "Limpar",
    value: "",
    label: "Limpar",
  },
];

export const drugFrequencyPast12MonthsOptions = [
  {
    code: "LA6270-8",
    display: "Nunca",
    value: "Never",
  },
  {
    code: "LA18926-8",
    display: "Mensalmente ou menos",
    value: "Monthly or less",
  },
  {
    code: "LA18927-6",
    display: "2-4 vezes por mês",
    value: "2-4 times a month",
  },
  {
    code: "LA18928-4",
    display: "2-3 vezes por semana",
    value: "2-3 times a week",
  },
  {
    code: "LA18929-2",
    display: "4 ou mais vezes por semana",
    value: "4 or more times a week",
  },
  {
    code: "",
    display: "Limpar",
    value: "",
  },
];

export const exerciseDaysPerWeekOptions = [
  {
    code: "0",
    display: "0 dias",
    value: "0",
  },
  {
    code: "1",
    display: "1 dia",
    value: "1",
  },
  {
    code: "2",
    display: "2 dias",
    value: "2",
  },
  {
    code: "3",
    display: "3 dias",
    value: "3",
  },
  {
    code: "4",
    display: "4 dias",
    value: "4",
  },
  {
    code: "5",
    display: "5 dias",
    value: "5",
  },
  {
    code: "6",
    display: "6 dias",
    value: "6",
  },
  {
    code: "7",
    display: "7 dias",
    value: "7",
  },
  {
    code: "",
    display: "Limpar",
    value: "",
  },
];

export const physicalActivityTypeOptions = [
  {
    code: "LA18940-0",
    display: "Walking",
    value: "Walking",
    label: "Caminhada",
  },
  {
    code: "LA18941-8",
    display: "Running",
    value: "Running",
    label: "Corrida",
  },
  {
    code: "LA18942-6",
    display: "Cycling",
    value: "Cycling",
    label: "Ciclismo",
  },
  {
    code: "LA18943-4",
    display: "Swimming",
    value: "Swimming",
    label: "Natação",
  },
  {
    code: "LA18944-2",
    display: "Weight training",
    value: "Weight training",
    label: "Musculação",
  },
  {
    code: "LA18945-9",
    display: "Aerobic exercise",
    value: "Aerobic exercise",
    label: "Exercício aeróbico",
  },
  {
    code: "LA18946-7",
    display: "Yoga",
    value: "Yoga",
    label: "Yoga",
  },
  {
    code: "LA18947-5",
    display: "Dancing",
    value: "Dancing",
    label: "Dança",
  },
  {
    code: "LA18948-3",
    display: "Other",
    value: "Other",
    label: "Outro",
  },
  {
    code: "",
    display: "Limpar",
    value: "",
    label: "Limpar",
  },
];

export const physicalActivityIntensityOptions = [
  {
    code: "LA18949-1",
    display: "Leve",
    value: "Light",
    label: "Leve",
  },
  {
    code: "LA18950-9",
    display: "Moderado",
    value: "Moderate",
    label: "Moderado",
  },
  {
    code: "LA18951-7",
    display: "Vigoroso",
    value: "Vigorous",
    label: "Vigoroso",
  },
  {
    code: "",
    display: "Limpar",
    value: "",
    label: "Limpar",
  },
];
